import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthStore } from '../services/auth-store';


export const authGuard: CanActivateChildFn = (route, state) => {
  const router = inject(Router);
  const auth = inject(AuthStore);

  const isLoggedIn = auth.isAuthenticated();

  // If not logged in → redirect to login
  if (!isLoggedIn) {
    router.navigate(['/']);
    return false;
  }

  // Otherwise → allow navigation
  return true;
};
